/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_checkout_computed_for_another_country = /** @type {(inputs: { countryCode: NonNullable<unknown> }) => string} */ (i) => {
	return `Ceny jsou zobrazeny včetně všech daní podle vaší doručovací země (${i.countryCode})`
};

const da_checkout_computed_for_another_country = /** @type {(inputs: { countryCode: NonNullable<unknown> }) => string} */ (i) => {
	return `Priserne vises inkl. moms i henhold til dit leveringsland (${i.countryCode})`
};

const de_checkout_computed_for_another_country = /** @type {(inputs: { countryCode: NonNullable<unknown> }) => string} */ (i) => {
	return `Die Preise werden inklusive Steuern entsprechend Ihrem Lieferland (${i.countryCode}) angezeigt`
};

const en_checkout_computed_for_another_country = /** @type {(inputs: { countryCode: NonNullable<unknown> }) => string} */ (i) => {
	return `Prices include tax according to your delivery country (${i.countryCode})`
};

const es_checkout_computed_for_another_country = /** @type {(inputs: { countryCode: NonNullable<unknown> }) => string} */ (i) => {
	return `Los precios se muestran con todos los impuestos incluidos según tu país de entrega (${i.countryCode})`
};

const fr_checkout_computed_for_another_country = /** @type {(inputs: { countryCode: NonNullable<unknown> }) => string} */ (i) => {
	return `Les prix sont affichés toutes taxes comprises selon votre pays de livraison (${i.countryCode})`
};

const hu_checkout_computed_for_another_country = /** @type {(inputs: { countryCode: NonNullable<unknown> }) => string} */ (i) => {
	return `Az árak az ÁFA-t tartalmazzák a szállítási ország szerint (${i.countryCode})`
};

const it_checkout_computed_for_another_country = /** @type {(inputs: { countryCode: NonNullable<unknown> }) => string} */ (i) => {
	return `I prezzi sono mostrati IVA inclusa in base al tuo paese di consegna (${i.countryCode})`
};

const nl_checkout_computed_for_another_country = /** @type {(inputs: { countryCode: NonNullable<unknown> }) => string} */ (i) => {
	return `Prijzen zijn inclusief btw volgens je afleverland (${i.countryCode})`
};

const pl_checkout_computed_for_another_country = /** @type {(inputs: { countryCode: NonNullable<unknown> }) => string} */ (i) => {
	return `Ceny zawierają podatek zgodnie z krajem dostawy (${i.countryCode})`
};

const pt_checkout_computed_for_another_country = /** @type {(inputs: { countryCode: NonNullable<unknown> }) => string} */ (i) => {
	return `Os preços são exibidos com todos os impostos incluídos de acordo com seu país de entrega (${i.countryCode})`
};

const sv_checkout_computed_for_another_country = /** @type {(inputs: { countryCode: NonNullable<unknown> }) => string} */ (i) => {
	return `Priserna visas inklusive moms enligt ditt leveransland (${i.countryCode})`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ countryCode: NonNullable<unknown> }} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const checkout_computed_for_another_country = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.checkout_computed_for_another_country(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("checkout_computed_for_another_country", locale)
	if (locale === "cs") return cs_checkout_computed_for_another_country(inputs)
	if (locale === "da") return da_checkout_computed_for_another_country(inputs)
	if (locale === "de") return de_checkout_computed_for_another_country(inputs)
	if (locale === "en") return en_checkout_computed_for_another_country(inputs)
	if (locale === "es") return es_checkout_computed_for_another_country(inputs)
	if (locale === "fr") return fr_checkout_computed_for_another_country(inputs)
	if (locale === "hu") return hu_checkout_computed_for_another_country(inputs)
	if (locale === "it") return it_checkout_computed_for_another_country(inputs)
	if (locale === "nl") return nl_checkout_computed_for_another_country(inputs)
	if (locale === "pl") return pl_checkout_computed_for_another_country(inputs)
	if (locale === "pt") return pt_checkout_computed_for_another_country(inputs)
	return sv_checkout_computed_for_another_country(inputs)
};
export { checkout_computed_for_another_country as "checkout.computed_for_another_country" }